// extracted by mini-css-extract-plugin
export default {"disableAnvilWidgetInteraction":"styles_disableAnvilWidgetInteraction__QI+LK"};